import { HeadCell, SearchResultColumn } from '@css-xp/base';

export interface EmailTableProps {
  transactionAccountId: string;
  partnerAccountId: string;
  isPaginationEnabled?: boolean;
  label?: string;
  testId?: string;
  attachmentRoute?: string;
  emailDetailsRoute?: string;
  hideFilters?: boolean;
  searchQuery?: string;
  isDesignIteration1Enabled?: boolean;
  isEmailsImprovementEnabled?: boolean;
}

export enum EmailTableColumns {
  SUBJECT = 'Subject',
  ATTACHMENT = 'Attachment',
  DATE = 'Date',
}

export interface FormData {
  searchTerm: string;
}

export interface DateRangeState {
  from?: string;
  to?: string;
}
export type ColumnList = HeadCell & SearchResultColumn;
